import type { ProductsInsightsReport } from 'model/ProductsInsightsReport';

export type ProductsInsightsReportState = {
    report: ProductsInsightsReport;
    loading: boolean;
};

export const emptyProductsInsightsReport: ProductsInsightsReport = {
    range: { start: '', end: '' },
    totals: {
        quantity: 0,
        grossSales: 0,
        discounts: 0,
        refunds: 0,
        netSales: 0,
        allNetSales: 0
    },
    meta: {
        page: 1,
        perPage: 10,
        totalCount: 0,
        totalPages: 1
    },
    products: []
};

export const initialProductsInsightsReportState: ProductsInsightsReportState = {
    report: emptyProductsInsightsReport,
    loading: false
};
